"use client";

import { FC } from "react";

interface DaysRangeSliderProps {
  lowPrice: number;
  highPrice: number;
  ltp: number;
  label?: string;
}

const calculateDayRangePosition = ( 
  ltp: number,
  low: number,
  high: number,
): number => {
  const safeLtp = Number(ltp ?? 0);
  const safeLow = Number(low ?? 0);
  const safeHigh = Number(high ?? 0);
  if (safeHigh === safeLow) return 50;
  const position = ((safeLtp - safeLow) / (safeHigh - safeLow)) * 100;
  return Math.max(0, Math.min(100, position));
};
 
export const DaysRangeSlider: FC<DaysRangeSliderProps> = ({
  lowPrice,
  highPrice,
  ltp,
  label,
}) => {
  const dayRangePosition = calculateDayRangePosition(ltp, lowPrice, highPrice); 
  const labelText = label ?? "Days Range";

  return (
    <div className="flex flex-col gap-[12px]">
      <div className="flex flex-col gap-[8px]">
        <div className="text-[12px] font-normal text-[#666666]">
          {labelText}
        </div>
        <div className="relative flex items-center justify-between">
          <span className="text-[14px] font-normal text-[#1a1a1a]">
            {Number(lowPrice ?? 0).toFixed(2)}
          </span>
          <span className="text-[14px] font-normal text-[#1a1a1a]">
            {Number(highPrice ?? 0).toFixed(2)}
          </span>
        </div>
      </div>{" "}
      <div className="relative">
        <div
          className="absolute top-0 -translate-x-1/2"
          style={{ left: `${dayRangePosition}%` }}
        />
        <i
          className="icomoon absolute -top-4 -translate-x-1/2 z-1 text-[#1a1a1a] before:content-['\e981'] text-[26px]"
          style={{
            left: `${dayRangePosition}%`,
          }}
        />
        <div
          className="h-2 w-full rounded-full"
          style={{
            background:
              "linear-gradient(to right, #b45151, #7b6d9a, #5c90d6, #62a6ab, #72b896)",
          }}
        />
      </div>
    </div>
  );
};
